import { flow } from 'mobx-state-tree';

export const fetchOptions = flow(function* (self) {
  if (self.gysService.useMock) return;

  try {
    const response = yield fetch(
      `${self.gysService.url}/get-your-spot/options`,
      {
        crossDomain: true,
        credentials: 'include',
      },
    );

    const json = yield response.json();

    self.mapBox.maxZoomLevel = json?.maxZoom || 9.5;
    self.features = json?.features ?? {
      favourites: false,
      search: false,
      parking: false,
    };
    self.mapBox.searchRadius = {
      small: 5000,
      medium: 10000,
      large: 50000,
      infinite: 0,
      // overwrite default values above with fields from json
      ...json?.searchRadius,
    };
    if (json?.mapboxKey && json?.MapboxStyleUrl) {
      self.mapBox.accessToken = json.mapboxKey;
      self.mapBox.styleUrl = json.MapboxStyleUrl;
    }
  } catch (error) {
    if (error.message !== 'The user aborted a request.') console.error(error);
  }
});
